import React from 'react'
import {Link} from 'react-router-dom'
import Pizza from '../assets/pizza.jpg'

import '../styles/Home.css'

const Home = () => {
  return (
    <div className="home" style={{backgroundImage: `url(${Pizza})`}}>
        <div className="headerContainer">
            <h1>Pizza's</h1>
            <p style={{fontStyle:'italic', color:'rgb(208, 22, 22)', backgroundColor:'white', width:'50%'}}>Thank you for choosing us for your pizza needs!</p>
            <Link to={'/menu'}>
                <button>Order Now</button>
            </Link>
        </div>
    </div>
  )
}

export default Home